module.exports = __webpack_public_path__ + "img/instagram-logo.267bd254.svg";